<template>

  <div class="min-h-screen flex flex-col justify-between">

    <div class="flex flex-col flex-1 items-center justify-center mt-6">

      <div class="bg-white rounded-xl shadow-md p-3 w-11/12 md:w-8/12 lg:w-5/12">

        <div class="flex justify-center items-center">
          <a class="text-center" href="/">
            <img src="@/assets/img/logo.png" class="p-2.5 w-24 h-auto" />
          </a>
        </div>

        <div class="w-full flex flex-col my-4 text-center">
          <h3 class="text-xl font-weight-bolder text-gray-800">{{ configuracionMeeting?.evento?.descripcion }}</h3>
          <h3 class="text-xl font-weight-bolder text-gray-500">{{ configuracionMeeting?.descripcion }}</h3>
          <h3 class="text-xl font-weight-bolder text-gray-500 mt-3">{{ $t('label.titulo.registro') }}</h3>
          <p class="text-base font-weight-bolder text-gray-400">{{ $t('label.complete.formulario') }}</p>
        </div>

        <div v-if="!isSubmitting && !empresa" class="w-full flex flex-col my-4 text-center">
          <h3 class="text-2xl font-weight-bolder text-gray-800 uppercase">{{ errorMessage }}</h3>
        </div>

        <div v-if="empresa">

          <div class="w-full flex flex-col my-4 text-center pt-3 pb-4 bg-gray-200 rounded-lg">
            <h3 class="text-xl font-semibold text-gray-800 uppercase">{{ empresa.razonSocial }}</h3>
          </div>

          <!-- Inicio del formulario pide DNI -->
          <div v-if="!acreditado">
            <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0 my-3">
              <div class="w-full px-2">
                <label class="block mb-1 text-sm text-gray-600">{{ $t('label.dni') }}</label>
                <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
                  <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.dni')"
                    :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                  <span class="text-sm text-red-500 p-error">
                    <ErrorMessage name="dni" />
                  </span>
                </Field>
              </div>
            </div>

            <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0 pt-6 px-2">
              <button @click="validarDni"
                class="w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[101%] active:scale-95"
                :disabled="isSubmitting">
                <font-awesome-icon :icon="['far', 'fa-id-card']" />
                {{ $t('boton.continuar') }}
              </button>
            </div>
          </div>

          <!-- Acreditado existente -->
          <div v-if="acreditado">
            <div class="w-full border border-gray-300 rounded-lg shadow-xs p-5 space-y-0 md:space-y-2">

              <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0">
                <div class="w-full px-2 md:w-6/12">
                  <label class="block mb-1 text-sm text-gray-600">{{ $t('label.nombre') }}</label>
                  <div class="text-xl font-bold">{{ acreditado.nombre }}</div>
                </div>
                <div class="w-full px-2 md:w-6/12">
                  <label class="block mb-1 text-sm text-gray-600">{{ $t('label.apellido') }}</label>
                  <div class="text-xl font-bold">{{ acreditado.apellido }}</div>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0">
                <div class="w-full px-2 md:w-6/12">
                  <label class="block mb-1 text-sm text-gray-600">{{ $t('label.cargo') }}</label>
                  <div class="text-xl font-bold">{{ acreditado.cargo }}</div>
                </div>
                <div class="w-full px-2 md:w-6/12">
                  <label class="block mb-1 text-sm text-gray-600">{{ $t('label.telefono') }}</label>
                  <div class="text-xl font-bold">{{ acreditado.telefono }}</div>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0">
                <div class="w-full px-2">
                  <label class="block mb-1 text-sm text-gray-600">{{ $t('label.mail') }}</label>
                  <div class="text-xl font-bold">{{ acreditado.mail }}</div>
                </div>
              </div>
            </div>

            <!-- Acreditado SIN password -->
            <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0 my-4" v-if="!acreditado.tienePassword">
              <div class="w-full px-2 md:w-6/12">
                <label class="block mb-1 text-sm text-gray-600">{{ $t('label.contrasenia') }}</label>
                <Field name="password" v-slot="{ field, errors }" v-model="formData.password">
                  <InputText v-bind="field" type="password" class="input-base" :placeholder="$t('label.contrasenia')"
                    :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                  <span class="text-sm text-red-500 p-error">
                    <ErrorMessage name="password" />
                  </span>
                </Field>
              </div>
              <div class="w-full px-2 md:w-6/12">
                <label class="block mb-1 text-sm text-gray-600">{{ $t('label.contrasenia.repetida') }}</label>
                <Field name="passwordRepetida" v-slot="{ field, errors }" v-model="formData.passwordRepetida">
                  <InputText v-bind="field" type="password" class="input-base"
                    :placeholder="$t('label.contrasenia.repetida')"
                    :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                  <span class="text-sm text-red-500 p-error">
                    <ErrorMessage name="passwordRepetida" />
                  </span>
                </Field>
              </div>
            </div>

            <!-- Acreditado CON password -->
            <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0 my-4" v-if="acreditado.tienePassword">
              <div class="w-full px-2">
                <label class="block mb-1 text-sm text-gray-600">{{ $t('label.contrasenia') }}</label>
                <Field name="password" v-slot="{ field, errors }" v-model="formData.password">
                  <InputText v-bind="field" type="password" class="input-base" :placeholder="$t('label.contrasenia')"
                    :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                  <span class="text-sm text-red-500 p-error">
                    <ErrorMessage name="password" />
                  </span>
                </Field>
              </div>
            </div>

            <div class="flex flex-wrap -mx-2 space-y-2 md:space-y-0 pt-6 px-2">
              <button @click="registrar"
                class="w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[101%] active:scale-95"
                :disabled="isSubmitting">
                <font-awesome-icon :icon="['fas', 'fa-check-double']" />
                {{ $t('boton.aceptar') }}
              </button>
            </div>
          </div>

        </div>

      </div>

      <div class="flex items-center gap-3 md:gap-4 my-6">
        <button @click="changeLanguage('es')" class="transition hover:scale-125 cursor-pointer">
          <img src="@/assets/img/ar.svg" class="h-6 md:h-8" />
        </button>
        <button @click="changeLanguage('en')" class="transition hover:scale-125 cursor-pointer">
          <img src="@/assets/img/us.svg" class="h-6 md:h-8" />
        </button>
      </div>

    </div>
  </div>

  <FullScreenLoader :visible="isSubmitting" />

</template>

<script lang="ts">
import { useForm } from 'vee-validate';

import { defineComponent } from 'vue';
import { Field, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import FullScreenLoader from '../commons/FullScreenLoader.vue';

import seguridadService from '@/services/seguridad.services';
import { Acreditado, ConfiguracionMeeting, Empresa, EstadoAcreditado, Evento, OrigenAcreditado } from 'qreventos-suite/src/services/suite.interfaces';
import idiomaService from '@/services/idioma.services';
import meetingService from 'qreventos-suite/meeting';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import empresaService from 'qreventos-suite/empresas';
import seguridadServices from '@/services/seguridad.services';
import suiteService from 'qreventos-suite/services';
import { ORIGEN_ACREDITADO, SAVE, UPDATE, VERIFICADO } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    InputText, FullScreenLoader,
    Field, ErrorMessage
  },
  setup() {
    const { setFieldError } = useForm();
    return {
      setFieldError
    };
  },
  data() {
    return {
      isSubmitting: false,
      configuracionMeeting: undefined as unknown as ConfiguracionMeeting,
      empresa: undefined as unknown as Empresa,
      errorMessage: '',
      acreditado: undefined as unknown as Acreditado,
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        cargo: '',
        telefono: '',
        mail: '',
        password: '',
        passwordRepetida: ''
      }
    };
  },
  methods: {
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      idiomaService.updateIdioma(lang);
    },
    async validarDni() {
      if (!this.formData.dni) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('errors.dni.required'), icon: "error" });
        return;
      }
      this.isSubmitting = true;

      try {
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        this.acreditado = await suiteService.findAcreditadoByDni(configuracionMeeting.evento.id, this.formData.dni) as Acreditado;
        if (!this.acreditado) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.debe.estar.acreditado'), icon: "warning" });
          return;
        }



      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    ingresoValido(): boolean {
      this.setFieldError('password', '');
      this.setFieldError('passwordRepetida', '');

      if (!this.formData.password) {
        this.setFieldError('password', this.$t('errors.ingrese.password'));
        return false;
      }

      if (this.formData.password.length < 8) {
        this.setFieldError('password', this.$t('errors.min.8.caracteres'));
        return false;
      }

      if (!this.acreditado.tienePassword) {
        if (!this.formData.passwordRepetida) {
          this.setFieldError('passwordRepetida', this.$t('errors.repetir.nueva.contrasenia'));
          return false;
        }

        if (this.formData.passwordRepetida.length < 8) {
          this.setFieldError('passwordRepetida', this.$t('errors.min.8.caracteres'));
          return false;
        }

        if (this.formData.password !== this.formData.passwordRepetida) {
          this.setFieldError('passwordRepetida', this.$t('errors.contrasenias.no.coinciden'));
          return false;
        }
      }
      return true;
    },
    async asociarAcreditadoEmpresa(): Promise<boolean> {
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
      return await empresaService.asociarAcreditadoEmpresa(configuracionMeeting.evento.id, this.empresa.id, this.acreditado.id);
    },
    async registrar() {
      this.errorMessage = "";
      this.isSubmitting = true;

      try {
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        if (!this.configuracionMeeting.activo) {
          Swal.fire({ title: "Error", html: this.$t('label.modulo.deshabilitado'), icon: "error" });
          return;
        }

        if (!this.ingresoValido()) {
          return;
        }

        let acreditadoAsociado: boolean = false;

        if (this.acreditado.tienePassword) {
          const hash: string = await suiteService.auth(configuracionMeeting.evento.id, this.acreditado.mail, this.formData.password, 2) as string; // 2 - Mail
          if (!hash) {
            return;
          } else {
            acreditadoAsociado = await this.asociarAcreditadoEmpresa();
          }
        } else {
          this.acreditado.passwd = this.formData.password;
          this.acreditado.modificado = UPDATE;

          console.log(this.acreditado);


          await suiteService.initPassword(configuracionMeeting.evento.id, this.acreditado.hash, this.acreditado.passwd)
          acreditadoAsociado = await empresaService.asociarAcreditadoEmpresa(configuracionMeeting.evento.id, this.empresa.id, this.acreditado.id);
        }

        if (acreditadoAsociado) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.registro.exitoso'), icon: "success" }).then(() => {
            this.logout();
          });
        }

      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
        this.formData.password = '';
      } finally {
        this.isSubmitting = false;
      }
    },
    logout() {
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      seguridadServices.logout();
      this.$router.push({ path: '/' + configuracionMeeting.contextUrl });
      configuracionMeetingService.remove();
    }
  },
  async mounted() {
    const context = this.$route.params.context;
    const hashEmpresa = this.$route.params.hashEmpresa;
    const idEmpresa = Number(atob(hashEmpresa));

    try {
      this.isSubmitting = true;

      this.configuracionMeeting = await meetingService.findByContext(context);
      if (this.configuracionMeeting) {
        configuracionMeetingService.save(this.configuracionMeeting);
        this.empresa = await empresaService.findEmpresaBy(this.configuracionMeeting.evento.id, idEmpresa);
        if (!this.empresa) {
          this.errorMessage = this.$t('"errors.empresa.no.existe"');
        }

        if (!this.empresa.activo) {
          this.empresa = undefined as unknown as Empresa;
          this.errorMessage = this.$t('errors.empresa.deshabilitada');
        }
      }

    } catch (error) {
      this.errorMessage = "Error : " + error;
      this.isSubmitting = false;
    } finally {
      this.isSubmitting = false;
    }
  }
});
</script>
